export default __webpack_public_path__ + "static/media/default.2e01288c.jpg";